import { render, staticRenderFns } from "./DynamicDisplay.vue?vue&type=template&id=abed60aa&scoped=true"
import script from "./DynamicDisplay.vue?vue&type=script&lang=js"
export * from "./DynamicDisplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abed60aa",
  null
  
)

export default component.exports